<template>
    <div class="web-view2">
        <div class="container "
             style="max-width: inherit; height: 500px; background-size: cover;"
             :style="{ 'background-image': 'url(' + backSrc + ')' }"
        >

            <div class=" row mx-0 w-100 pt-5 " style="justify-content: center">
                <div class="col-lg-3 text-center  align-self-center" style="max-height: 170px !important;">
                    <div>
                        <img :src="validateImageUrl(companyModel.companyLogoImage)" class="logo-img">
                    </div>
                </div>
                <div class="col-lg-5 text-center m-3">
                    <h2>{{companyModel.name}}</h2>
                    <h4>{{companyModel.description1}}</h4>
                    <h6>{{companyModel.description2}}</h6>
                    <h6 class="mt-3">با مدیریت : {{companyModel.managerName}}</h6>
                </div>
                <div class="col-lg-3 text-center  align-self-center" style="max-height: 170px !important;">
                    <div>
                        <img :src="validateImageUrl(companyModel.organLogoImage)" class="logo-img">
                    </div>
                </div>
            </div>

            <div class="row mx-0  w-100 mt-5" style="justify-content: center">
                <div class="card m-lg-4"
                     style="border-radius: 5rem; padding: 1.5rem; box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.65);">
                    <div class="text-center">
                        <h5 class="m-lg-4"> خلاصه فعالیتها</h5>
                        <p class="text-center image-editor" v-html="companyModel.article"></p>
                    </div>
                    <div class="text-center mt-5">
                        <h5 class="m-lg-4">رزومه شرکت و پروژه ها</h5>
                        <p class="text-center image-editor" v-html="companyModel.project"></p>
                    </div>
                </div>
            </div>

            <div class="row mx-0  w-100 mt-3">

            </div>

            <div class=" row mx-0  w-100 mt-5 " style="justify-content: center">
                <div class="col-lg-3 text-center  align-self-center" style="max-height: 90px !important;">
                    <div>
                        <img :src="validateImageUrl(companyModel.companyLogoImage)" class="logo-img2">
                    </div>
                </div>
                <div class="col-lg-5 text-center m-3">
                    <p v-if="companyModel.address!==null&&companyModel.address!==''"> آدرس :
                        {{companyModel.address}} </p>
                    <span v-if="companyModel.mobile!==null&&companyModel.mobile!==''"> موبایل : {{companyModel.mobile}} </span>
                    <span v-if="companyModel.tel1!==null&&companyModel.tel1!==''">  تلفن : {{companyModel.tel1}} </span>
                    <span v-if="companyModel.fax!==null&&companyModel.fax!==''">  فکس : {{companyModel.fax}} </span>
                    <!--<p class=""> آدرس : {{companyModel.address}} تلفن : {{companyModel.tel1}} فکس : {{companyModel.fax}}-->
                    <!--موبایل : {{companyModel.mobile}}</p>-->
                    <p class="text-center clickable text-info" style="font-weight: bolder;" @click="gotohome">ورود به
                        پنل مدیریت</p>
                    <p class="">
                        <small class="mt-3"> کلیه حقوق متعلق به {{companyModel.name}} میباشد.</small>
                        <small class="mt-3"> طراحی و اجرا : <a href="https://charkhoune.ir/">چرخونه</a></small>
                    </p>
                </div>
                <div class="col-lg-3 text-center  align-self-center" style="max-height: 90px !important;">
                    <div>
                        <img :src="validateImageUrl(companyModel.organLogoImage)" class="logo-img2">
                    </div>
                </div>

            </div>


        </div>
    </div>
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import * as $ from "jquery";
    import Constants from "../_framework/Constants";


    export default {
        name: 'sitePage',
        components: {},
        data() {
            return {
                isLoading: false,
                companyModel: {},
                backSrc: "",


            }
        },
        mounted() {
            // this.getDashboardData();
            // if (userName === undefined || userName === "") {
            //     this.$noty.error('لطفا ابتدا وارد حساب کاربری خود شوید!');
            //     this.$router.push({name: "login"})
            // }
            // this.role = localStorage.getItem('role');
            // this.getDashboardData();
            // $("body").addClass("polygon");
            // $("body").addClass("login");
            this.getcompanyData();

        },
        methods: {
            getcompanyData() {
                this.isLoading = true;
                new BaseService("Company", "/GetCompany").getList().then(response => {
                    this.isLoading = false;
                    this.companyModel = response.data;
                    if (this.companyModel.siteImage === undefined || this.companyModel.siteImage === null || this.companyModel.siteImage === '') {
                        this.backSrc = '/img/background4.jpg';
                    } else {
                        this.backSrc = Constants.BASE_URL + this.companyModel.siteImage;
                    }
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getDashboardData() {
                this.isLoading = true;
                new BaseService("Dashboard", "/index").getList().then(response => {
                    this.isLoading = false;

                    this.userContractDate = response.data.userContractDate;
                    this.engineerContractDate = response.data.engineerContractDate;
                    this.projectDate = response.data.projectDate;
                    this.engineerMembershipDate = response.data.engineerMembershipDate;
                    this.check = response.data.check;
                    this.contract = response.data.contract;
                    this.companyMembership = response.data.companyMembership;
                    this.companyParvaneh = response.data.companyParvaneh;
                    this.engineerParvaanehDate = response.data.engineerParvaanehDate;
                    this.calibration = response.data.calibration;
                    this.requestSampling = response.data.requestSampling;
                    this.resultSampling = response.data.resultSampling;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                // new BaseService("ReportMainMatches", "/GetMatchesForDashboard").getList().then(response => {
                //     console.log(response.data);
                //     this.lastMaches = response.data.data;
                // }).catch(error => {
                //     Utils.handleErrorWithNotification(error.data, this.$noty);
            },
            onViewMessageClicked(id) {

                this.$router.push({
                    name: 'myRequst',
                });
            },
            gotohome() {
                this.$router.push({
                    name: 'home',
                });
            },
            // validateDate(date) {
            //     return Moment(date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY')
            // },
            // onRowClicked(id){
            //     this.$router.push({
            //         name: 'competitionsList',
            //         params: {
            //             id: id
            //         }
            //     });
            // },
        },
        // beforeRouteLeave(to, from, next) {
        //     $("body").removeClass("polygon");
        //     next();
        // }        ,

    }
</script>

<style lang="scss" scoped>

    @font-face {
        font-family: 'Shabnam';
        src: url('/fonts//Shabnam-FD.woff2') format('woff2'),
        url('/fonts/Shabnam-FD.woff') format('woff');
        font-weight: normal;
    }

    @font-face {
        font-family: 'Shabnam';
        src: url('/fonts/Shabnam-Bold-FD.woff2') format('woff2'),
        url('/fonts/Shabnam-Bold-FD.woff') format('woff');
        font-weight: bold;
    }

    @font-face {
        font-family: 'Shabnam';
        src: url('/fonts/Shabnam-Light-FD.woff2') format('woff2'),
        url('/fonts/Shabnam-Light-FD.woff') format('woff');
        font-weight: 200;
    }

    body {

        text-align: right !important;
        font-family: 'Shabnam', Tahoma, sans-serif;
        direction: rtl !important;
    }

    .web-view2 {
        text-align: right !important;
        font-family: 'Shabnam', Tahoma, sans-serif;
        direction: rtl !important;
    }

    img {
        width: auto !important;
    }

    .image-editor {
        .image {
            max-width: 90% !important;
        }
        img {
            width: auto !important;
        }
        .img {
            width: auto !important;
        }
    }

    .image-editor .image {
        max-width: 90% !important;
    }

    .image-editor .img {
        max-width: 90% !important;
    }

    .logo-img {
        max-height: 130px;
        max-width: 130px;

    }

    .logo-img2 {
        max-height: 90px;
        max-width: 90px;

    }

    .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057 !important;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 3rem;
        -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    }

    .form-control:focus {
        border-color: #ced4da;
        border-width: 1px;
        background-color: #ffffff;
        box-shadow: 0 0 15px -5px rgba(0, 0, 0, 0.25);
    }

    .clickable {
        cursor: pointer;
    }


</style>